<header
  class="header container"
  (click)="closeProfileMenu($event, headerContent)">
  <!-- header languages menu & phone info -->
  <section class="header__top-info">
    <!-- tell section -->
    <a href="tel:+982191093981" class="tell-section">
      <i class="iconsax tell-section__tell-icon" icon-name="phone"></i>
      <span class="tell-section__tell-container">
        <span class="tell-section__tell-prefix">+98</span>
        <span class="tell-section__tell-value">2191093981</span>
      </span>
    </a>

    <!-- languages menu -->

    <ul class="languages-menu" dir="rtl">
      @for (lang of languagesMenuItems; track lang?.id) {
        <li
          class="languages-menu__lang-item"
          [ngClass]="{
            'languages-menu__lang-item--active': selectedLang === lang.code,
          }"
          (click)="setLang(lang.code)">
          {{ lang?.name }}
        </li>
      }
    </ul>
  </section>

  <section class="header__content-container">
    <!-- header content section - logo & menu & login btns -->
    <div class="header__content" (mouseleave)="toggleMegaMenu()" #headerContent>
      <!-- header logo -->
      <a class="header__logo" routerLink="">
        <img
          class="logo-image"
          ngSrc="assets/icons/logo-wejoiner.svg"
          alt="weJoiner"
          height="512"
          width="512" />
      </a>
      <!-- header menu -->
      <ul class="header-menu">
        @for (item of menu; track item) {
          <li
            class="header-menu__item"
            routerLinkActive="header-menu__item--active"
            [routerLinkActiveOptions]="{ exact: !!item.exact }"
            (mouseover)="toggleMegaMenu(item.link)">
            <a class="header-menu__item-link" [routerLink]="item.link">
              <i
                class="iconsax header-menu__item-icon"
                [attr.icon-name]="item.icon"></i>
              <span class="header-menu__item-text">
                {{ item.name | translate }}
              </span>
            </a>
          </li>
        }

        <!-- quick order -->
        <a routerLink="/quick-orders" class="header-menu__order-btn">
          <img
            class="order-btn-img"
            ngSrc="assets/icons/order-icon.png"
            width="28"
            height="28"
            alt="" />
          <span class="order-btn-text">{{
            'routes.quickOrders' | translate
          }}</span>
        </a>

        @if (!hiddenMegaMenu && productCategories) {
          <section class="mega-menu">
            <pwj-mega-menu [categoriesData]="productCategories"></pwj-mega-menu>
          </section>
        }
      </ul>

      <!-- header login & buy packages -->
      @defer {
        <div class="header-btns">
          @if (user?.username) {
            <pwj-button
              class="header-btns__login"
              [buttonClasses]="'!h-40'"
              variant="secondary"
              icon="user-1"
              iconClasses="!text-3xl"
              (click)="toggleProfileMenu()">
              <span>
                {{ 'global.account' | translate }}
              </span>
            </pwj-button>
          } @else {
            <pwj-button
              class="header-btns__login"
              [buttonClasses]="'!h-40 yektanet__header-login-btn'"
              matomoClickCategory="Authentication"
              matomoClickAction="Login"
              matomoClickName="Header"
              variant="secondary"
              icon="user-1"
              iconClasses="!text-3xl"
              (click)="toggleProfileMenu()">
              <span>
                {{ 'header.login' | translate }}
              </span>
            </pwj-button>
          }

          <!-- packages button -->
          @if (!user.business && user.type === 'PERSONAL') {
            <pwj-button
              (click)="openUpgrade()"
              class="header-btns__upgrade"
              buttonClasses="!h-40"
              variant="info"
              iconClasses="!text-3xl"
              icon="award-3"
              [iconReversePosition]="true">
              {{ 'global.businessAccount' | translate }}
            </pwj-button>
          }
        </div>
      } @placeholder (minimum 1500ms) {
        <ngx-skeleton-loader
          count="1"
          class="flex gap-30"
          [theme]="{
            width: '6em',
            height: '2.3em',
            'border-radius': '0.625em',
          }"></ngx-skeleton-loader>

        <!-- packages button -->
        @if (!user.business && user.type === 'PERSONAL') {
          <div>
            <ngx-skeleton-loader
              count="1"
              class="flex gap-30"
              [theme]="{
                width: '6em',
                height: '2.3em',
                'border-radius': '0.625em',
              }"></ngx-skeleton-loader>
          </div>
        }
      }
    </div>

    <!-- profile menu -->
    <pwj-profile-menu [hidden]="hiddenProfileMenu"></pwj-profile-menu>
  </section>
</header>

<!-- header search & filters -->
@if (showSearchBar && hiddenMegaMenu && hiddenProfileMenu) {
  <section class="header__search-container container">
    <!-- header filters btn -->
    <pwj-home-search-section [wFull]="true"></pwj-home-search-section>
  </section>
}
